export const LINKS = {
  SIGNUP: '/signup',
  SIGNIN: '/signin',
  OVERVIEW: '/overview',
  BLOG: '/blog',
  BLOG_ELEMENT: '/blog/:id',
  DEPLOYMENTS: '/deployments',
  DEPLOYMENT_LOGS: '/deploymentLogs',
  CONTACT: '/contact',
  DOWNLOAD: '/download',
  SUBMISSION: '/submission',
  LICENSE: '/license',
  NOT_FOUND: '*',
  HOME: '/',
  EMAIL: '/verify-email',
  PROFILE: '/profile',
  RESET_PASSWORD: '/reset-password',
  SENSORS: '/overview#sensors',
};
